//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { transTimeFilter } from "../../../src/filters"
import { Popover } from "vant"

const load = vm => {
  // 重新加载 audio
  vm.audioRef.load()
  // 监听 audio 事件
  vm.audioRef.oncanplay = () => {
    vm.duration = vm.audioRef.duration
    vm.playedTime = vm.audioRef.currentTime
  }
  // 监听播放时间变化
  vm.audioRef.ontimeupdate = () => {
    vm.playedTime = vm.audioRef.currentTime
    // selfRequestAnimationFrame()
    vm.progress = vm.duration > 0 ? ((vm.playedTime * 100) / (vm.duration * 100)).toFixed(5) * 100 : 0
  }
  // 监听暂停
  vm.audioRef.onpause = () => {
    vm.onPause()
  }
}

export default {
  name: "VocAudioPlayer",
  componentName: "VocAudioPlayer",
  components: { Popover },
  filters: { transTimeFilter },
  props: {
    // 录音组件唯一标识
    // 用来控制 audio 标签相关逻辑
    id: {
      type: String,
      required: true
    },
    // 录音名称
    name: {
      type: String,
      default: ""
    },
    // 录音链接
    link: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      // 标志位
      // 用来判断是否处于播放状态
      playing: false,
      // 语音总时长
      duration: 0,
      // 当前已播放时间
      playedTime: 0,
      // 剩余播放时间
      // restTime: 0,
      // 控制进度条
      progress: 0,
      waveCanvasWidth: 300,
      rateShow: false,
      actions: [
        {
          text: "2.0x",
          value: 2.0
        },
        {
          text: "1.5x",
          value: 1.5
        },
        {
          text: "1.25x",
          value: 1.25
        },
        {
          text: "1.0x",
          value: 1.0
        },
        {
          text: "0.75x",
          value: 0.75
        },
        {
          text: "0.5x",
          value: 0.5
        }
      ],
      currentRate: {
        text: "1.0x",
        value: 1.0
      }
    }
  },
  computed: {
    // audio dom
    audioRef() {
      return this.$refs[this.id]
    },
    isWav() {
      // 判断是否 wav 格式音频，目前只有 wav 或者 mp3
      return this.link.indexOf(".wav") !== -1
    },
    mp3Link() {
      return this.link.toString().replace(".wav", ".mp3")
    },
    wavLink() {
      return this.link.toString().replace(".mp3", ".wav")
    },
    actionsList() {
      return this.actions.map(item => {
        if (item.value === this.currentRate.value) {
          item.className = "active"
        } else {
          item.className = ""
        }
        return item
      })
    }
  },
  watch: {},
  created() {
    // 利用父组件进行广播，子组件监听事件
    // 目的是：停止所有非当前播放id的audio组件的播放状态
    this.$on("voc-audio-stop", v => {
      if (`${v}` != `${this.id}` && this.audioRef) {
        this.onPause()
      }

      if (!v) {
        this.progress = 0
        this.playedTime = 0
        load(this)
      }
    })
  },
  mounted() {
    if (this.link) {
      load(this)
    }
  },
  methods: {
    isDragHorizontal(d2, d1) {
      console.log(Math.abs(d2.clientX - d1.clientX) > Math.abs(d2.clientY - d1.clientY), "ratio")
      return Math.abs(d2.clientX - d1.clientX) > Math.abs(d2.clientY - d1.clientY)
    },
    setCurrentTime(time) {
      this.audioRef && (this.audioRef.currentTime = time)
    },
    /**
     * progress {Number} 进度比例，0~1的小数
     */
    seek(progress) {
      if (progress > 1) progress = 1
      if (progress < 0) progress = 0
      this.progress = progress * 100
      this.setCurrentTime(progress * this.duration)
    },
    getStageWidth(dom) {
      return this.__stageWidth || (this.__stageWidth = dom.getBoundingClientRect().width)
    },
    onDragSeekStart(e) {
      this.__lastMove = e.touches[0]
    },
    onDragSeek(e) {
      let move = e.touches[0]
      if (this.__lastMove && this.isDragHorizontal(move, this.__lastMove) && e.cancelable) {
        e.preventDefault()
        e.stopPropagation()
        // console.log(this.progress / 100, 'progress',(move.clientX - this.__lastMove.clientX), (move.clientX - this.__lastMove.clientX) / this.getStageWidth(e.currentTarget))
        this.seek(this.progress / 100 + (move.clientX - this.__lastMove.clientX) / this.getStageWidth(e.currentTarget))
        this.__lastMove = move
      }
    },
    onClickSeek(e) {
      console.log(e.offsetX, e.clientX, e.offsetX / this.getStageWidth(e.currentTarget))
      this.seek(e.offsetX / this.getStageWidth(e.currentTarget))
    },
    // 执行播放
    onPlay() {
      if (this.link) {
        if (this.playedTime === this.duration) {
          this.setCurrentTime(0)
        }
        let palyPromise = this.audioRef && this.audioRef.play()
        if (palyPromise !== undefined) {
          palyPromise
            .then(() => {
              this.playing = true
              this.setCurrentTime(this.playedTime)
              this.$emit("voc-audio-played", this.id)
            })
            .catch(error => {
              console.log(error)
            })
        }
      }
    },
    onMobilePlay() {
      if (this.link) {
        // load(this)
        this.onPlay()
      }
    },
    // 暂停播放
    onPause() {
      if (this.playing) {
        this.playing = false
        this.audioRef && this.audioRef.pause()
      }
    },
    // 播放完成
    onEnded() {
      this.playing = false
      this.setCurrentTime(0)
    },
    // 快进或快退
    changeTime(type) {
      if (type === "back") {
        if (this.playedTime >= 15) {
          this.setCurrentTime(this.playedTime - 15)
        } else {
          this.setCurrentTime(0)
        }
      } else {
        if (this.playedTime < this.duration - 15) {
          this.setCurrentTime(this.playedTime + 15)
        } else {
          this.setCurrentTime(this.duration - 1)
        }
      }
    },
    getContainer() {
      return this.$refs["voc-audio"]
    },
    selectRate(item) {
      this.currentRate = item
      this.audioRef && (this.audioRef.playbackRate = item.value)
    }
  }
}
